import { captureException } from "utils/errorReporting";

const dynamicImportErrors = [
  "Importing a module script failed.",
  "Failed to fetch dynamically imported module",
  "error loading dynamically imported module",
].map((e) => e.toLowerCase());

const isStaleChunkError = (error: Error): boolean => {
  const haystack = (error.stack ?? error.message).toLowerCase();
  return dynamicImportErrors.some((needle) => haystack.includes(needle));
};

export function reportRouteError(error: unknown): void {
  // A cached app referencing a chunk a deploy replaced — reload to fetch the new build, don't report.
  if (error instanceof Error && isStaleChunkError(error)) {
    globalThis.location.reload();
    return;
  }
  // captureException wraps non-Errors via toError(), so route throwables no longer collapse to "<unknown>".
  captureException(error);
}
